__turbopack_context__.v({
  "isActive": "BlockSubNavCardGroupSubNav-module-scss-module__c0qJoW__isActive",
  "item": "BlockSubNavCardGroupSubNav-module-scss-module__c0qJoW__item",
  "itemIcon": "BlockSubNavCardGroupSubNav-module-scss-module__c0qJoW__itemIcon",
  "root": "BlockSubNavCardGroupSubNav-module-scss-module__c0qJoW__root",
});
